import { removeSessionWorktrees } from '../../remove-session-worktrees.js';
import type { SessionWorktreeCache } from '../session-worktree-cache.js';

export async function removeSessionWorktreeCheckouts(
  cache: SessionWorktreeCache,
  sessionId: string,
  worktreesRootPath: string,
  log: (msg: string) => void,
): Promise<void> {
  const paths = cache.clearSession(sessionId);
  if (!paths?.length) return;
  await removeSessionWorktrees(paths, worktreesRootPath, log);
}
